import { Layout, Menu } from "antd";
import {
  DashboardOutlined,
  FileTextOutlined,
  PlusOutlined,
  RobotOutlined,
  CalendarOutlined,
  BookOutlined,
  ReadOutlined,
  TableOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Sider } = Layout;

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: "/",
      icon: <ReadOutlined />,
      label: "Archivo Texto",
    },
    {
      key: "/catalogo",
      icon: <BookOutlined />,
      label: "Catalogo Referencias",
    },
    {
      key: "/dashboard",
      icon: <DashboardOutlined />,
      label: "Dashboard",
    },
    {
      key: "/new-case",
      icon: <PlusOutlined />,
      label: "Nuevo Caso",
    },
    {
      key: "/ai-assistant",
      icon: <RobotOutlined />,
      label: "Asistente IA",
    },
    {
      key: "/deadlines",
      icon: <CalendarOutlined />,
      label: "Plazos",
    },
    {
      key: "/documents",
      icon: <FileTextOutlined />,
      label: "Documentos",
    },
    {
      key: "/planilla",
      icon: <TableOutlined />,
      label: "Planilla",
    },
  ];

  const selected =
    location.pathname === "/archivo" ? "/" : location.pathname;

  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
      style={{
        overflow: "auto",
        height: "100vh",
        position: "sticky",
        top: 0,
        left: 0,
        background: "#0f2923",
      }}
    >
      <div
        style={{
          height: 64,
          margin: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#efe6d6",
          fontSize: "22px",
          fontWeight: 700,
          fontFamily: '"Fraunces", Georgia, serif',
          letterSpacing: "-0.02em",
        }}
      >
        Comarca
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selected]}
        items={menuItems}
        onClick={({ key }) => navigate(key)}
        style={{ background: "#0f2923" }}
      />
    </Sider>
  );
};

export default Sidebar;
